import React, {Component, Fragment} from "react";
import Modal from 'react-modal';
import ChevronLeft from "mdi-react/ChevronLeftIcon";
import ChevronRight from "mdi-react/ChevronRightIcon";
import CloseIcon from "mdi-react/CloseIcon";
import "./PhotoProductModal.scss";
import Analytics from "../../libs/analytics";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import store from "../../store/store";
import * as actionType from "../../store/actions";
import Common from "../../utils/common";

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: '1000'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        borderRadius: '0',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        backgroundColor: 'transparent',
        overflow: 'hidden',
        border: 0,
        padding: '0 25px'
    }
};

class PhotoProductModal extends Component {
    state={
        modalOpen: false,
        product: null,
        selectedIndex: null,
        enableNext: false,
        enablePrev: false,
        asset: null,
        userHashId: null
    }
    closeModal = () => {
        store.dispatch({
            type: actionType.UPDATE_PRODUCT_MODAL,
            product_modal: {
                modalOpen: false,
                product: null,
                selectedIndex: null,
                enableNext: false,
                enablePrev: false,
                asset: null,
                userHashId: null
            }
        });
    }
    componentDidMount(){
        store.subscribe(this.handleProductSore);
    }
    handleProductSore = () => {
        const storeState = store.getState();
        if(storeState.event === actionType.UPDATE_PRODUCT_MODAL) {
            this.setState({...storeState.product_modal});
        }
    }
    onNext = (getNext) => {
        const {selectedIndex} = this.state;
        if(getNext)
            this.props.getNewProduct(selectedIndex+1)

    }
    onPrev = (getPrev) => {
        const {selectedIndex} = this.state;
        if(getPrev)
            this.props.getNewProduct(selectedIndex-1)
    }

    formatPrice(price) {
        return price && typeof price === "string" ? (price.indexOf("$") >= 0 ? price : ("$" + price)) : price
    }

    generatePrice = (entity) => {
        const product = entity.data && typeof entity.data === 'object' ? {...entity, ...entity.data} : entity;
        if (product.sale_price_effective_dates && product.price_sale) {
            const dates = product.sale_price_effective_dates.split("/");
            const dateStart = new Date(dates[0]), dateEnd = new Date(dates[1]), now = new Date();
            if (now >= dateStart && now <= dateEnd)
                return <span><strike
                    className={"old-price"}>{this.formatPrice(product.price)}</strike> {this.formatPrice(product.price_sale)}</span>;

        }
        return this.formatPrice(product.price)
    }
    handleClick = (e) => {
        Analytics.productClick(this.state.product, this.state.product.entityIdParent);
		Analytics._GA_EVENTS('event',{
			'Event_category' : 'videos',
			'Event_action': 'tvp:product:click',
			'Event_label' : this.state.product.title
		});
        return e;
    }
    productUrl = () => {
        const {product, asset, userHashId} = this.state;
        return Common.getProductLink(product, asset.id, userHashId);
    }
    render() {
        const {product, modalOpen, enablePrev, enableNext} = this.state;
        const nextClass = !enableNext ? "disable-next" : "";
        const prevClass = !enablePrev ? "disable-prev" : "";
        return <Fragment>
            <Modal
                isOpen={modalOpen}
                bodyOpenClassName={'TVPAGE'}
                onRequestClose={this.closeModal}
                style={customStyles}>
                {product && <div className={"tvp-modal-product-holder"}>
                    <div onClick={this.closeModal} className={"tvp-modal-product-close"}><CloseIcon/></div>
                    <div onClick={()=>this.onPrev(enablePrev)} className={"tvp-modal-product-arrow tvp-modal-product-prev "+prevClass}><ChevronLeft size={'58px'}/></div>
                    <div onClick={()=>this.onNext(enableNext)} className={"tvp-modal-product-arrow tvp-modal-product-next "+nextClass}><ChevronRight size={'58px'}/></div>
                    <a href={this.productUrl()} onClick={this.handleClick} target={'_blank'}>
                        <div className={"tvp-modal-product"}>

                            <div className={"embed-responsive embed-responsive-1by1 tvp-modal-product-thumbnail"}>
                                <div className={"embed-responsive-item"}
                                     style={{backgroundImage: `url(${product.imageUrl})`}}>

                                </div>
                            </div>
                            <div className={"tvp-modal-product-title"}>
                                {product.title}
                            </div>
                            <div className={"tvp-modal-product-price"}>
                                {this.generatePrice(product)}
                            </div>
                            <div className={"tvp-modal-product-buy-now text-center"}>
                                <button>{ConfigurationHelper.getProductsCTAModalText()}</button>
                            </div>
                        </div>
                    </a>
                </div>}
            </Modal>
        </Fragment>
    }
}

export default PhotoProductModal;